import {action, Action} from 'easy-peasy';

interface SortTypeFieldChoice {
    id: number;
    name: string;
    value: string;
}

interface SortTypeFieldChoicesState {
    items: SortTypeFieldChoice[];
    loadSortTypeFieldChoices: Action<SortTypeFieldChoicesState, SortTypeFieldChoice[]>;
}

const sortTypeFieldChoices: SortTypeFieldChoicesState = {
    items: [],
    loadSortTypeFieldChoices: action((state, sortTypeFieldChoicesList) => {
        state.items = sortTypeFieldChoicesList;
    }),
};

export default sortTypeFieldChoices;
